module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container page-not-found"
  }, [_vm._m(0), _c('router-link', {
    staticClass: "themed text",
    attrs: {
      "to": _vm.url
    }
  }, [_vm._v("返回")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "ui center aligned icon header"
  }, [_c('i', {
    staticClass: "rocket icon"
  }), _c('div', {
    staticClass: "content"
  }, [_vm._v("未能找到请求页面")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17233e2f","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/PageNotFound.vue
// module id = 433
// module chunks = 0